var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form',{staticClass:"mb-2",attrs:{"inline":""}},[_c('b-form-input',{staticClass:"d-inline mb-1",attrs:{"placeholder":_vm.$t('message.SearchPlaceholder'),"type":"text"},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}})],1),_c('vue-good-table',{attrs:{"style-class":"vgt-table striped","columns":_vm.columns,"rows":_vm.data,"sort-options":{
      enabled: true,
      initialSortBy: {field: 'fullName', type: 'asc'}
    },"search-options":{
      enabled: true,
      externalQuery: _vm.searchTerm },"select-options":{
      enabled: false,
      selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
      selectionInfoClass: 'custom-class',
      selectionText: 'rows selected',
      clearSelectionText: 'clear',
      disableSelectInfo: true, // disable the select info panel on top
    },"pagination-options":{
      enabled: true,
      perPage:_vm.pageLength,
      mode: 'records',
      perPage: 10,
      perPageDropdown: [10, 50, 100],
      dropdownAllowAll: false,
    }},scopedSlots:_vm._u([{key:"table-column",fn:function(props){return [_c('span',[_vm._v(" "+_vm._s(_vm.$t(props.column.label))+" ")])]}},{key:"table-row",fn:function(props){return [(props.column.field === 'status')?_c('span',{staticClass:"text-nowrap"},[_c('b-badge',{staticClass:"text-capitalize",attrs:{"pill":"","variant":("light-" + (_vm.resolveStatus(props.row[props.column.field])))}},[_vm._v(" "+_vm._s(props.row[props.column.field])+" ")])],1):_c('span',[_vm._v(" "+_vm._s(props.formattedRow[props.column.field])+" ")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }